/**
 * Zoom hands an app its identity as an encrypted "app context" string. The client sends it with the
 * first request for the page, but not with calls the page makes later, so the page reads it from the
 * SDK (getAppContext) and attaches it to every call itself.
 */
let appContext: string | null = null;

export function setZoomAppContext(value: string | null): void {
  appContext = value;
}

export function zoomContextHeaders(): Record<string, string> {
  return appContext ? { 'X-Zoom-App-Context': appContext } : {};
}
